module.exports = InternalShared('InternalShared/Events/UpdateFieldSettingsPanel');